const languages = {
    MX: {
        passwords: 'Contraseñas',
        passwordswifi: 'Contraseñas de WiFi',
        notes: 'Notas',
        logout: 'Cerrar Sesión',
        copy: 'Copiar al portapapeles',
        gosite: 'Ir al sitio',
        deleteLabel: 'Eliminar',
        instructions: 'Haz clic en una contraseña',
        titleEdit: 'Editar contraseña',
        showPassword: 'Mostrar contraseña',
        hidePassword: 'Ocultar contraseña',
        notesPlaceholder: 'Deje notas que sean utiles para esta contraseña emails, recordatorios etc.',
        usernameLabel: 'Username',
        passwordLabel: 'Contraseña',
        notesLabel: 'Notas',
        pickColorLabel: 'Color de contraseña',
        closeLabel: 'Cerrar',
        saveLabel: 'Guardar',
        confirmDelete: '¿Quieres eliminar esta contraseña?',
        yesLabel: 'Si',
        noLabel: 'No',
        nameLabel: 'Nombre',
        urlPlaceholder: 'Ejemplo: https://www.google.com',
        namePlaceholder: 'Nombre de la contraseña',
        passwordPlaceholder: 'Tu contraseña super secreta ;)',
        passwordAddedTitle: 'Contraseña agregada',
        passwordUpdatedTitle: 'Contraseña modificada',
        passwordFailedTitle: 'Algo fallo :(',
        passwordFailedMessage: 'Durante la transacción algo ocurrió',
        passwordDeletedTitle: '¡Contraseña eliminada!',
        signInLabel: 'Inicia sesión con tu correo y tu clave maestra',
        emailAddressLabel: 'Correo electronico',
        loginLabel: 'Iniciar Sesion',
        noAccountLabel: '¿No tienes cuenta?',
        registerLabel: 'Registrar',
        titleLandingHeader: "Aubert, tu memorizador de contraseñas",
        descriptionLandingLabel: "Aubert te ayuda a guardar tus contraseñas para iniciar sesion. Si viajas mucho y/o cambias de telefono, tambien puedes agregar contraseñas de WiFi. O si quieres apuntar algo para verlo despues, puedes hacer notas.",
        registerTitleLabel: "¡Registrate en Aubert!",
        registerInstructionsLabel: "Escribe estos datos para registrarte.",
        fullNameRegisterLabel: "Nombre completo",
        loginFromRegisterLabel: "¿Ya tienes una cuenta?",
        sessionFoundTitleLabel: "Tienes una sesion iniciada en este dispositivo. ¿Quieres invalidar la otra sesion y volver a iniciar sesion?",
        sessionFoundTitleNoButtonLabel: "Por favor cierra esta ventana y ve a la que esta abierta la aplicacion.",
        confirmDeleteNote: '¿Quieres eliminar esta nota?',
        noteDeletedTitle: '¡Nota eliminada!',
        savingLabel: 'Guardando',
        searchNotesLabel: 'Buscar Notas',
        searchPasswordLabel: 'Buscar Contraseñas',
        sessionFoundTitle: 'Sesión encontrada',
        landingPageTitle: 'Aplicacion que te ayuda a gestionar tus contraseñas y notas',
        viewToAble: 'Tienes que ver la contraseña para poder editarla.',
        copiedToClipboard: 'Contraseña copiada en el portapapeles.',
    }, 
    EN: {
        passwords: 'Passwords',
        passwordswifi: 'WiFi passwords',
        notes: 'Notes',
        logout: 'Logout',
        copy: 'Copy to clipboard',
        gosite: 'Go the site',
        deleteLabel: 'Delete',
        instructions: 'Click on a password',
        titleEdit: 'Edit password',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        notesPlaceholder: 'Leave notes that are useful for this password emails, reminders etc.',
        usernameLabel: 'Username',
        passwordLabel: 'Password',
        notesLabel: 'Notes',
        pickColorLabel: 'Password color',
        closeLabel: 'Close',
        saveLabel: 'Save',
        confirmDelete: 'You want to delete this password?',
        yesLabel: 'Yes',
        noLabel: 'No',
        nameLabel: 'Name',
        urlPlaceholder: 'Example: https://www.google.com',
        namePlaceholder: 'Name of the password',
        passwordPlaceholder: 'Your super secret password ;)',
        passwordAddedTitle: 'Password added',
        passwordUpdatedTitle: 'Password modified',
        passwordFailedTitle: 'Something failed :(',
        passwordFailedMessage: 'During the transaction something happened',
        passwordDeletedTitle: 'Deleted password!',
        signInLabel: 'Sign in with your mail and your master key',
        emailAddressLabel: 'Email Address',
        loginLabel: 'Login',
        noAccountLabel: "Don't have an account?",
        registerLabel: 'Register',
        titleLandingHeader: "Aubert, your password memorizer",
        descriptionLandingLabel: "Aubert helps you save your passwords to log in. If you travel a lot and/or change phones, you can also add WiFi passwords. Or if you want to write something down to see it later, you can make notes.",
        registerTitleLabel: "Register in Aubert!",
        registerInstructionsLabel: "Enter these details to register.",
        fullNameRegisterLabel: "Full Name",
        loginFromRegisterLabel: "Do you have an account?",
        sessionFoundTitleLabel: "You are logged in on this device. Do you want to invalidate the other session and start the session again?",
        sessionFoundTitleNoButtonLabel: "Please close this window and go to the one where the application is open.",
        confirmDeleteNote: 'You want to delete this note?',
        noteDeletedTitle: 'Note deleted!',
        savingLabel: 'Saving',
        searchNotesLabel: 'Search Notes',
        searchPasswordLabel: 'Search Passwords',
        sessionFoundTitle: 'Session Found',
        landingPageTitle: 'Application that helps you manage your passwords and notes',
        viewToAble: 'You have to see the password to be able to edit it.',
        copiedToClipboard: 'Password copied to clipboard.',

    },
    FR: {
        passwords: 'Mots de passe',
        passwordswifi: 'Mots de passe Wi-Fi',
        notes: 'Notes',
        logout: 'Fermer la session',
        copy: 'Copier dans le presse-papier',
        gosite: 'Aller sur le site',
        deleteLabel: 'Retirer',
        instructions: 'Cliquez sur un mot de passe',
        titleEdit: 'Éditer mot de passe',
        showPassword: 'Montrer le mot de passe',
        hidePassword: 'Masquer le mot de passe',
        notesPlaceholder: 'Laissez des notes utiles pour ce mot de passe, les e-mails, les rappels, etc.',
        usernameLabel: "Nom d'utilisateur",
        passwordLabel: 'Mot de passe',
        notesLabel: 'Notes',
        pickColorLabel: 'Couleur de mot de passe',
        closeLabel: 'Proche',
        saveLabel: 'Sauvegarder',
        confirmDelete: 'Voulez-vous supprimer ce mot de passe?',
        yesLabel: 'Oui',
        noLabel: 'Non',
        nameLabel: 'Nom',
        urlPlaceholder: 'Exemple: https://www.google.com',
        namePlaceholder: 'Nom du mot de passe',
        passwordPlaceholder: 'Tu mot de passe super secrète ;)',
        passwordAddedTitle: 'Mot de passe ajouté',
        passwordUpdatedTitle: 'Mot de passe changé',
        passwordFailedTitle: "Quelque chose s'est mal passé :(",
        passwordFailedMessage: "Pendant la transaction, il s'est passé quelque chose",
        passwordDeletedTitle: 'Mot de passe supprimé!',
        signInLabel: 'Connectez-vous avec votre mail et votre clé principale',
        emailAddressLabel: 'Eddresse E-mail',
        loginLabel: 'Connexion',
        noAccountLabel: "Vous n'avez pas de compte?",
        registerLabel: "S'inscrire",
        titleLandingHeader: "Aubert, votre mémoriseur de mots de passe",
        descriptionLandingLabel: "Aubert vous aide à enregistrer vos mots de passe pour vous connecter. Si vous voyagez beaucoup et/ou changez de téléphone, vous pouvez également ajouter des mots de passe WiFi. Ou si vous voulez écrire quelque chose pour le voir plus tard, vous pouvez prendre des notes.",
        registerTitleLabel: "Inscrivez-vous à Aubert!",
        registerInstructionsLabel: "Entrez ces détails pour vous inscrire.",
        fullNameRegisterLabel: "Nom et prénom",
        loginFromRegisterLabel: "Avez-vous un compte?",
        sessionFoundTitleLabel: "Vous êtes connecté sur cet appareil. Voulez-vous valider l'autre session et recommencer la session?",
        sessionFoundTitleNoButtonLabel: "Veuillez fermer cette fenêtre et vous rendre dans celle où l'application est ouverte.",
        confirmDeleteNote: 'Voulez-vous supprimer ce note?',
        noteDeletedTitle: 'Note supprimé!',
        savingLabel: 'Enregistrement',
        searchNotesLabel: 'Notes de Recherche',
        searchPasswordLabel: 'Rechercher des mots de passe',
        sessionFoundTitle: 'Séance Trouvée',
        landingPageTitle: 'Application qui vous aide à gérer vos mots de passe et vos notes',
        viewToAble: 'Vous devez voir le mot de passe pour pouvoir le modifier.',
        copiedToClipboard: 'Mot de passe copié dans le presse-papiers.',

    }
}

export function getWord(language, word) {
    return languages[language][word]
}